import cx from 'classnames';
import React from 'react';
import { Icon } from 'assets/icons';
import styles from './view-toggle.module.css';

const VIEW_OPTIONS = [
  { key: 'list', label: 'List view', icon_name: 'list_view' },
  { key: 'board', label: 'Board view', icon_name: 'board_view' }
];

export const ViewToggle = ({ active_view = 'board', onChange = () => {} }) => (
  <div className={styles.toggle}>
    {VIEW_OPTIONS.map((option) => (
      <button
        key={option.key}
        type="button"
        title={option.label}
        aria-label={option.label}
        className={cx(styles.option, active_view === option.key && styles.active)}
        onClick={() => onChange(option.key)}
      >
        <Icon name={option.icon_name} width={18} height={18} />
      </button>
    ))}
  </div>
);
